export enum ServiceType {
  Reservation = 'reservation',
  Parking = 'parking',
}
